import React from "react";
import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import moment from "moment";
import {
    ModalContainer,
    ModalHeader,
    ModalContent,
    ScrollableContent,
    ModalSection,
} from "../../Styles/InputStyles";
import { FaMoneyBillWave, FaCalendarAlt } from "react-icons/fa";
import ModalProfileHeader from "../../Common/ModalProfileHeader";
import { capitalizeFirstLetter } from "../../../helpers";
import {
    HiOutlineArrowDownTray,
    HiOutlineArrowUpTray,
} from "react-icons/hi2";

const ViewStaffWalletTransfers = ({
    setViewModal,
    selectedData,
    data,
}) => {
    const onClose = () => {
        setViewModal(false);
    };

    const transfers = data || [];

    return (
        <ModalContainer>
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">
                    Transfer History
                </h1>

                <button type="button" onClick={onClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>

            <ModalProfileHeader
                title="Staff Details"
                name={capitalizeFirstLetter(selectedData?.name)}
                subtitle={`#${selectedData?.mobile}`}
                amountLabel="Current Balance"
                amount={selectedData?.balance}
                onClose={onClose}
            />

            <ModalContent>
                <ScrollableContent>
                    <Wrapper>
                        <SectionHeader>
                            <SectionTitle>
                                Transfer History
                            </SectionTitle>

                            <TransferCount>
                                {transfers.length}{" "}
                                {transfers.length === 1
                                    ? "Transfer"
                                    : "Transfers"}
                            </TransferCount>
                        </SectionHeader>

                        <ModalSection>
                            {transfers.length > 0 ? (
                                <div className="space-y-3">
                                    {transfers.map((transfer, index) => {
                                        const amount = Number(
                                            transfer?.amount ??
                                            transfer?.totalAmount ??
                                            0
                                        );

                                        const transferDate =
                                            transfer?.transferDate ||
                                            transfer?.createdAt;

                                        const isWithdraw =
                                            String(transfer?.transferBy) ===
                                            String(selectedData?.staffId);

                                        return (
                                            <TransferCard
                                                key={transfer?.id || index}
                                                isWithdraw={isWithdraw}
                                            >
                                                <div className="flex items-center gap-3 min-w-0">
                                                    {/* <IconWrapper isWithdraw={isWithdraw}>
                    {isWithdraw ? (
                        <HiOutlineArrowDownTray />
                    ) : (
                        <HiOutlineArrowUpTray />
                    )}
                </IconWrapper> */}

                                                    <div className="min-w-0">
                                                        <div className="flex items-center gap-2">
                                                            <Label>
                                                                {isWithdraw
                                                                    ? "Withdrawn"
                                                                    : "Transferred"}
                                                            </Label>
                                                        </div>

                                                        <Amount>
                                                            ₹{amount.toLocaleString("en-IN")}
                                                        </Amount>
                                                    </div>
                                                </div>

                                                <DateInfo>
                                                    <div>
                                                        <Label>Transfer Date</Label>

                                                        <DateValue>
                                                            {transferDate
                                                                ? moment(transferDate).format(
                                                                    "DD MMM yyyy, hh:mm A"
                                                                )
                                                                : "-"}
                                                        </DateValue>
                                                    </div>
                                                </DateInfo>
                                            </TransferCard>
                                        );
                                    })}
                                </div>
                            ) : (
                                <EmptyState>
                                    No transfer history found
                                </EmptyState>
                            )}
                        </ModalSection>
                    </Wrapper>
                </ScrollableContent>
            </ModalContent>
        </ModalContainer>
    );
};

const Wrapper = tw.div`
    grid
    gap-3
    my-0
`;

const SectionHeader = tw.div`
    w-full
    flex
    items-center
    justify-between
    mb-1
`;

const SectionTitle = tw.div`
    text-sm
    font-semibold
    text-gray-800
`;

const TransferCount = tw.span`
    text-xs
    text-gray-400
`;

const TransferCard = tw.div`
    w-full
    px-4
    py-3.5
    rounded-lg
    bg-white
    border
    border-gray-200
    flex
    items-center
    justify-between
    gap-4
    transition-all
    duration-200
    hover:border-gray-300
    hover:shadow-sm
`;

const TransferInfo = tw.div`
    flex
    items-center
    gap-3
    min-w-0
`;

const IconWrapper = tw.div`
    w-9
    h-9
    rounded-lg
    bg-gray-50
    border
    border-gray-100
    flex
    items-center
    justify-center
    text-gray-500
    flex-shrink-0
`;

const DateInfo = tw.div`
    flex
    items-center
    gap-2
    flex-shrink-0
`;

const Label = tw.div`
    text-[11px]
    text-gray-400
    mb-0.5
`;

const Amount = tw.div`
    text-sm
    font-semibold
    text-gray-900
    tabular-nums
`;

const DateValue = tw.div`
    text-xs
    font-medium
    text-gray-600
    whitespace-nowrap
`;

const EmptyState = tw.div`
    text-center
    py-8
    text-sm
    text-gray-400
`;

const TransactionBadge = tw.span`
    inline-flex
    items-center
    px-2
    py-0.5
    rounded-full
    text-[10px]
    font-medium
    ${({ isWithdraw }) =>
        isWithdraw
            ? "bg-orange-50 text-orange-600"
            : "bg-green-50 text-green-600"}
`;
export default ViewStaffWalletTransfers;